import { useNavigate } from 'react-router-dom'

const NotFound = () => {
  const navigate = useNavigate()
  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center px-4">
      <div className="text-center">
        <p className="text-8xl font-bold text-gray-800 mb-4">404</p>
        <h1 className="text-2xl font-bold text-white mb-2">Pagina non trovata</h1>
        <p className="text-gray-500 text-sm mb-8">Questa pagina non esiste o è stata spostata.</p>
        <button
          onClick={() => navigate('/')}
          className="bg-violet-600 hover:bg-violet-500 text-white font-medium px-6 py-3 rounded-lg transition-colors"
        >
          Torna alla Dashboard
        </button>
      </div>
    </div>
  )
}

export default NotFound
